import { CommonModule, CurrencyPipe, IMAGE_LOADER, ImageLoaderConfig } from "@angular/common";
import { Component, Inject, OnInit, PLATFORM_ID } from "@angular/core";
import { CloudinaryModule, lazyload, placeholder } from "@cloudinary/ng";
import { Cloudinary, CloudinaryImage, Transformation } from "@cloudinary/url-gen";
import { opacity } from "@cloudinary/url-gen/actions/adjust";
import { format, quality } from "@cloudinary/url-gen/actions/delivery";
import { colorize } from "@cloudinary/url-gen/actions/effect";
import { source } from "@cloudinary/url-gen/actions/overlay";
import { scale } from "@cloudinary/url-gen/actions/resize";
import { Position } from "@cloudinary/url-gen/qualifiers";
import { auto } from "@cloudinary/url-gen/qualifiers/quality";
import { image } from "@cloudinary/url-gen/qualifiers/source";
import { Client, JobSidebarPageComponent } from "@interfaces";
import { GtagService } from "src/app/containers/gtag/gtag.service";
import { SubdomainService } from "src/app/rest/subdomain.service";
import { VideosService } from "src/app/rest/videos.service";
import { convertJobAddress } from "src/app/routes/jobs/job-helpers";
import { ComponentActionsService } from "../../services/component-actions.service";
import { AbstractComponent } from "../abstract-component";
import { ApplyButtonComponent } from "../apply-button/apply-button.component";
import { ReferButtonComponent } from "../refer-button/refer-button.component";

@Component({
    selector: "app-job-sidebar",
    templateUrl: "./job-sidebar.component.html",
    standalone: true,
    imports: [CommonModule, CloudinaryModule, ApplyButtonComponent, ReferButtonComponent],
    providers: [
        CurrencyPipe,
        {
            provide: IMAGE_LOADER,
            useValue: (config: ImageLoaderConfig) => {
                return `https://res.cloudinary.com/${config.src}`;
            },
        },
    ],
})
export class JobSidebarComponent extends AbstractComponent implements OnInit {
    public locationString = "";
    public component: JobSidebarPageComponent;
    public textStyles = {};
    public client: Client;
    public logoUrl = '';
    public img: CloudinaryImage;
    public plugins = [lazyload(), placeholder({ mode: 'predominant-color' })];
    public salaryString = "";


    constructor(
        private currency: CurrencyPipe,
        protected actionsService: ComponentActionsService,
        protected videoService: VideosService,
        protected gtag: GtagService,
        @Inject(PLATFORM_ID) protected platform,
        private subdomain: SubdomainService
    ) {
        super(actionsService);
    }

    ngOnInit(): void {
        this.setupLocationData();
        this.calculateImage();
        this.subdomain.getClient().subscribe(client => {
            this.client = client;
            this.textStyles = this.calculateTextStyles();
        });
        if (this.job?.salary?.label) {
            this.salaryString = this.job?.salary?.label;
        } else if (this.job?.salary?.from && this.job.salary?.to) {
            this.salaryString = `${this.currency.transform(
                this.job.salary.from,
                this.job.salary.currency
            )} - ${this.currency.transform(this.job.salary.to, this.job.salary.currency)} ${this.job.salary.type}`;
        }
    }

    private calculateImage() {
        const cld = new Cloudinary({ cloud: { cloudName: "minirobot" } });
        this.img = cld.image(this.component?.logo?.public_id).delivery(quality(auto())).delivery(format(auto()));;
        this.img.resize(scale().width(100));

        if (!this.published) {
            this.img.overlay(
                source(
                    image("voyse:assets:draft").transformation(
                        new Transformation().effect(colorize(20).color("white")).adjust(opacity(20))
                    )
                ).position(new Position().allowOverflow(false))
            );
        }
    }

    private calculateTextStyles() {
        return { color: 'var(--textColor)' };
	}

    private setupLocationData() {
        const formattedAddress = convertJobAddress(this.job?.locationMeta);
        this.locationString =
            this.job?.locationLabel ||
            formattedAddress?.addressLocality ||
            formattedAddress?.addressRegion ||
            this.job?.location;
    }
}
